// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery.swiper {
  max-width: 100%;
  padding-top: 40px;
}
.gallery.swiper .logo {
  padding: 0 50px;
  position: absolute;
}
.gallery.swiper .text {
  text-decoration: none;
  position: absolute;
  top: 86%;
  right: 5%;
  font-size: 35px;
  font-weight: bold;
}
.gallery.swiper img {
  width: 100%;
}
.gallery.swiper .swiper-container {
  width: 100%;
  height: 100%;
}
.gallery.swiper .swiper-wrapper {
  padding-bottom: 35px;
}
@media screen and (min-width: 495px) {
  .gallery.swiper .swiper-wrapper {
    padding-bottom: 40px;
  }
}
.gallery.swiper .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 400px !important;
}
.gallery.swiper .swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0 !important;
  padding-top: 12px !important;
}

.swiper-pagination-bullet {
  background: #ffffff !important;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 12px;
  height: 12px;
} `, "",{"version":3,"sources":["webpack://./src/components/Gallery/gallery.scss","webpack://./src/components/Gallery/gallery.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;ACCF;ADAE;EACE,eAAA;EACA,kBAAA;ACEJ;ADAE;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;ACEJ;ADAE;EACE,WAAA;ACEJ;ADAE;EACE,WAAA;EACA,YAAA;ACEJ;ADAE;EACE,oBAAA;ACEJ;ADDI;EAFF;IAGI,oBAAA;ECIJ;AACF;ADFE;EAGE,aAAA;EAIA,uBAAA;EAIA,mBAAA;EACA,kBAAA;EACA,uBAAA;ACIJ;ADHI;EACE,cAAA;EACA,WAAA;EACA,YAAA;ECFJ,iBDGI;ACKN;;ADAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;ACGF;;ADDA;EACE,8BAAA;ACIF;;ADDA;EACE,WAAA;EACA,YAAA;ACIF","sourcesContent":[".gallery.swiper {\n  max-width: 100%;\n  padding-top: 40px;\n  .logo {\n    padding: 0 50px;\n    position: absolute;\n  }\n  .text {\n    text-decoration: none;\n    position: absolute;\n    top: 86%;\n    right: 5%;\n    font-size: 35px;\n    font-weight: bold;\n  }\n  img {\n    width: 100%;\n  }\n  .swiper-container {\n    width: 100%;\n    height: 100%;\n  }\n  .swiper-wrapper {\n    padding-bottom: 35px;\n    @media screen and (min-width: 495px) {\n      padding-bottom: 40px;\n    }\n  }\n  .swiper-slide {\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-align-items: center;\n    align-items: center;\n    text-align: center;\n    width: 400px !important;\n    img {\n      display: block;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n}\n\n.swiper-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  bottom: 0 !important;\n  padding-top: 12px !important;\n}\n.swiper-pagination-bullet {\n  background: #ffffff !important;\n}\n\n.swiper-pagination-bullet.swiper-pagination-bullet-active {\n  width: 12px;\n  height: 12px;\n}\n",".gallery.swiper {\n  max-width: 100%;\n  padding-top: 40px;\n}\n.gallery.swiper .logo {\n  padding: 0 50px;\n  position: absolute;\n}\n.gallery.swiper .text {\n  text-decoration: none;\n  position: absolute;\n  top: 86%;\n  right: 5%;\n  font-size: 35px;\n  font-weight: bold;\n}\n.gallery.swiper img {\n  width: 100%;\n}\n.gallery.swiper .swiper-container {\n  width: 100%;\n  height: 100%;\n}\n.gallery.swiper .swiper-wrapper {\n  padding-bottom: 35px;\n}\n@media screen and (min-width: 495px) {\n  .gallery.swiper .swiper-wrapper {\n    padding-bottom: 40px;\n  }\n}\n.gallery.swiper .swiper-slide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 400px !important;\n}\n.gallery.swiper .swiper-slide img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.swiper-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  bottom: 0 !important;\n  padding-top: 12px !important;\n}\n\n.swiper-pagination-bullet {\n  background: #ffffff !important;\n}\n\n.swiper-pagination-bullet.swiper-pagination-bullet-active {\n  width: 12px;\n  height: 12px;\n} /*# sourceMappingURL=gallery.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
